import { ref } from 'vue'
import { defineStore } from 'pinia'
import { ECountry } from '@/shared/enum/country.enum'
import { EEnvironment } from '@/shared/enum/enviroment.enum'

export const useAppStore = defineStore('app', () => {
  const country = ref<ECountry>(ECountry.GT)
  const enviroment = ref<EEnvironment>(EEnvironment.PROD)
  const isLoading = ref<boolean>(false)
  const persistLoading = ref<boolean>(false)

  const setCountry = (_country: ECountry) => {
    country.value = _country
  }

  const setLoading = (_loading: boolean) => {
    isLoading.value = _loading
  }

  const setEnviroment = (_enviroment: EEnvironment) => {
    enviroment.value = _enviroment
  }

  const setPersistLoading = (_persistLoading: boolean) => {
    persistLoading.value = _persistLoading
  }

  return {
    country,
    enviroment,
    isLoading,
    persistLoading,
    setCountry,
    setLoading,
    setEnviroment,
    setPersistLoading
  }
})
